<template>
  <div class="Setup">
    <a-row class="Setup-head">
      <a-col :span="12">
        <p>系统设置</p>
      </a-col>
      <a-col :span="10"></a-col>
      <a-col :span="2">
        <a v-on:click="back">返回</a>
      </a-col>
    </a-row>
    <a-collapse id="Setup-content" defaultActiveKey="2">
      <!-- <a-collapse-panel header="基础设置" key="1">
        <a-row>
          <a-col :span="10">Lora通讯信道</a-col>
          <a-col :span="10">{{Config&& Config.LoraChannel? Config.LoraChannel+" 信道":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm('LoraChannel')"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">轨迹纠偏</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.LocationRecordRectify!=undefined ? (Config.LocationRecordRectify?"开启":"关闭"):"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm('LocationRecordRectify')"></div>
          </a-col>
        </a-row>
      </a-collapse-panel>-->
      <a-collapse-panel header="门限设置" key="2">
        <a-row>
          <a-col :span="10">设备电量</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.EquipmentBattery? "&lt;&nbsp;" + Config.EquipmentBattery+ " %":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('EquipmentBattery')"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">队员心率(高)</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.TeamHeartRateMax? "> " + Config.TeamHeartRateMax+ " 次/分钟":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('TeamHeartRateMax')"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">队员心率(低)</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.TeamHeartRateMin? "&lt;&nbsp;" + Config.TeamHeartRateMin+ " 次/分钟":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('TeamHeartRateMin')"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">环境温度</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.AmbienTemperature? "> " + Config.AmbienTemperature+ " ℃":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('AmbienTemperature')"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">出发时长</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.TimeOfDeparture? "> " + Config.TimeOfDeparture+ " 分钟":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('TimeOfDeparture')"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">空呼剩余时长</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.CallRemainingTime? "&lt;&nbsp;" + Config.CallRemainingTime+ " 分钟":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('CallRemainingTime')"></div>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="10">队员体温</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.BodySurfaceTemperatureMin? "< " + Config.BodySurfaceTemperatureMin+ " ℃":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('BodySurfaceTemperatureMin')"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10">血氧浓度</a-col>
          <a-col
            :span="10"
          >{{Config&&Config.BloodOxygenMin? "&lt;&nbsp;" + Config.BloodOxygenMin+ " %":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('BloodOxygenMin')"></div>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="10">空呼压力</a-col>
          <a-col
            :span="10"
          >{{Config&& Config.CallPressure? "&lt;&nbsp;" + Config.CallPressure+ " Mpa":"-"}}</a-col>
          <a-col :span="4">
            <div class="edit" @click="EditTerm2('CallPressure')"></div>
          </a-col>
        </a-row>
      </a-collapse-panel>
    </a-collapse>
    <div class="Setup-button">
      <a-button type="primary" @click="FactoryReset()">恢复默认设置</a-button> 
    </div>
    <a-modal
      :title="editTitle"
      v-model="editvisible"
      width="360px"
      :centered="true"
      class="Setup-model"
      okText="确定修改"
      cancelText="取消"
      @ok="EditOK()"
    >
      <ul class="edit-select" v-if="!editIsInput">
        <li
          v-for="item in editList"
          v-bind:class="{ checked: item.value == editSelect}"
          @click="Editselect(item.value)"
          :key="item"
        >{{item.name}}</li>
      </ul>
      <div v-if="editIsInput" style="padding:20px">
        <a-input
          size="large"
          :addonBefore="editIsInputHead"
          :addonAfter="editIsInputEnd"
          v-model="editSelect"
          placeholder="请输入门限值"
        />
      </div>
    </a-modal>

    <a-modal
      title="修改密码"
      v-model="updatePwdvisible"
      width="360px"
      :centered="true"
      okText="确定修改"
      cancelText="取消"
      @ok="updatePwdOk"
    >
      <input
        type
        name
        placeholder="请输入新密码"
        style="width:100%;height:40px;border:1px solid #e8e8e8;text-align: center"
        v-model="newPassword"
      />
    </a-modal>
  </div>
</template>
<script scoped>
import { Component, Vue } from "vue-property-decorator";
import SetupService from "../api/SetupService";
export default {
  components: {},
  data() {
    return {
      SetupList: [],
      Config: null,
      ConfigModel: null,
      editTitle: "",
      editvisible: false,
      editType: "",
      editIsInput: false,
      editIsInputHead: "",
      editIsInputEnd: "",
      editList: [],
      editSelect: null,
      LoraChannelList: [
        { name: "1通道", value: 1 },
        { name: "2通道", value: 2 },
        { name: "3通道", value: 3 },
        { name: "4通道", value: 4 },
        { name: "5通道", value: 5 },
        { name: "6通道", value: 6 },
        { name: "7通道", value: 7 },
        { name: "8通道", value: 8 }
      ],
      LocationRecordRectifyList: [
        { name: "开启", value: true },
        { name: "关闭", value: false }
      ],
      TroopInfo: {},
      updatePwdvisible: false,
      newPassword: "" 
    };
  },
  computed: {
    /*Config() {
      return this.$store.state.Config;
    }*/
  },
  created() {
    this.GetTroopConfig();
    this.TroopInfo = this.$store.state.troopInfo
    
  },
  mounted() {},
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    GetTroopConfig() {
      let troopsID =this.$store.state.troopInfo.TroopsID;
      SetupService.getSetupList({ TroopsID: troopsID }).then(
        res => {
          if (res.status == 200 && res.data.status == 1000) {
            this.$store.commit("setConfig", res.data.data);
            this.Config = res.data.data;
          } else if (res.status == 200) {
            self.$message.warning(res.data.msg);
          } else {
            self.$message.warning(res.message);
          }
        },
        err => {
          this.$message.warning(err.message);
        }
      );
    },
    FactoryReset() {
      var self = this;
      this.$confirm({
        title: "确定恢复默认设置?",
        // content: "原设置的值将会丢失",
        okText: "恢复默认设置",
        cancelText: "取消",
        centered: true,
        width: 320,
        onOk() {
          SetupService.FactoryReset().then(
            res => {
              console.log(res);
              if (res.status == 200 && res.data.status == 1000) {
                self.$message.success("恢复默认设置成功");
                self.GetTroopConfig();
              } else if (res.status == 200) {
                self.$message.warning(res.data.msg);
              } else {
                self.$message.warning(res.message);
              }
            },
            err => {
              this.$message.warning(err.message);
            }
          );
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    },
    SignOut() {
      this.$confirm({
        title: "确定退出SAS应急单兵作战系统?",
        // content: "原设置的值将会丢失",
        okText: "退出应用",
        cancelText: "取消",
        centered: true,
        width: 320,
        onOk() {
          RSWEBJS.SignOut();
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    },
    Shutdown() {
      RSWEBJS.Shutdown();
    },
    GetConfig() { 
      SetupService.GetConfig().then(
        res => {
          if (res.status == 200) {
            if (res.data.status == 1000) {
              console.log(res.data.data);
              this.$store.commit("setConfig", res.data.data);
            }
          } else {
            setTimeout(() => {
              this.GetConfig();
            }, 5000);
          }
        },
        err => {
          setTimeout(() => {
            this.GetConfig();
          }, 5000);
        }
      );
    },
    EditTerm(type) {
      if (!!!this.Config) {
        return;
      }
      this.editIsInput = false;
      switch (type) {
        case "LoraChannel":
          this.editTitle = "设置Lora通讯信道";
          this.editType = "LoraChannel";
          this.editList = this.LoraChannelList;
          this.editSelect = this.Config.LoraChannel;
          break;
        case "LocationRecordRectify":
          this.editTitle = "是否开启轨迹纠偏";
          this.editType = "LocationRecordRectify";
          this.editList = this.LocationRecordRectifyList;
          this.editSelect = this.Config.LocationRecordRectify;
          break;
        default:
          return;
      }
      this.editvisible = true;
    },
    EditTerm2(type) {
      if (!!!this.Config) {
        return;
      }
      this.editIsInput = true;
      switch (type) {
        case "EquipmentBattery":
          this.editTitle = "设置设备电量门限";
          this.editType = "EquipmentBattery";
          this.editSelect = this.Config.EquipmentBattery;
          this.editIsInputHead = "<";
          this.editIsInputEnd = "%";
          break;
        case "TeamHeartRateMax":
          this.editTitle = "设置队员心率门限";
          this.editType = "TeamHeartRateMax";
          this.editSelect = this.Config.TeamHeartRateMax;
          this.editIsInputHead = ">";
          this.editIsInputEnd = "次/分钟";
          break;
        case "TeamHeartRateMin":
          this.editTitle = "设置队员心率门限";
          this.editType = "TeamHeartRateMin";
          this.editSelect = this.Config.TeamHeartRateMin;
          this.editIsInputHead = "<";
          this.editIsInputEnd = "次/分钟";
          break;
        case "AmbienTemperature":
          this.editTitle = "设置环境温度门限";
          this.editType = "AmbienTemperature";
          this.editSelect = this.Config.AmbienTemperature;
          this.editIsInputHead = ">";
          this.editIsInputEnd = "℃";
          break;
        case "TimeOfDeparture":
          this.editTitle = "设置出发时长门限";
          this.editType = "TimeOfDeparture";
          this.editSelect = this.Config.TimeOfDeparture;
          this.editIsInputHead = ">";
          this.editIsInputEnd = "分钟";
          break;
        case "CallRemainingTime":
          this.editTitle = "设置空呼剩余时长门限";
          this.editType = "CallRemainingTime";
          this.editSelect = this.Config.CallRemainingTime;
          this.editIsInputHead = "<";
          this.editIsInputEnd = "分钟";
          break;
        case "CallPressure":
          this.editTitle = "设置空呼压力门限";
          this.editType = "CallPressure";
          this.editSelect = this.Config.CallPressure;
          this.editIsInputHead = "<";
          this.editIsInputEnd = "Mpa";
          break;
        case "BodySurfaceTemperatureMin":
          this.editTitle = "设置体温门限";
          this.editType = "BodySurfaceTemperatureMin";
          this.editSelect = this.Config.BodySurfaceTemperatureMin;
          this.editIsInputHead = "<";
          this.editIsInputEnd = "°C";
          break;
        case "BloodOxygenMin":
          this.editTitle = "设置血氧门限";
          this.editType = "BloodOxygenMin";
          this.editSelect = this.Config.BloodOxygenMin;
          this.editIsInputHead = "<";
          this.editIsInputEnd = "%";
          break;
        default:
          return;
      }

      this.editvisible = true;
    },
    Editselect(val) {
      this.editSelect = val;
    },
    EditOK() {
      var self = this;
      var value = this.editSelect;

      switch (this.editType) {
        case "EquipmentBattery":
          value = Number(value);
          this.Config.EquipmentBattery = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }

          if (value < 0 || value > 99) {
            this.$message.warning("请输入正确的门限值,门限值在0到99之间");
            return;
          }

          break;
        case "TeamHeartRateMax":
          value = Number(value);
          this.Config.TeamHeartRateMax = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }
          if (value < 0 || value > 200) {
            this.$message.warning("请输入正确的门限值,门限值在0到200之间");
            return;
          }
          if (value < this.Config.TeamHeartRateMin) {
            this.$message.warning(
              "请输入正确的门限值,门限值不小于" + this.Config.TeamHeartRateMin
            );
            return;
          }
          break;
        case "TeamHeartRateMin":
          value = Number(value);
          this.Config.TeamHeartRateMin = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }
          if (value < 0 || value > 200) {
            this.$message.warning("请输入正确的门限值,门限值在0到200之间");
            return;
          }
          if (value > this.Config.TeamHeartRateMax) {
            this.$message.warning(
              "请输入正确的门限值,门限值不大于" + this.Config.TeamHeartRateMax
            );
            return;
          }
          break;
        case "np":
          value = Number(value);
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }

          if (value < 0 || value > 200) {
            this.$message.warning("请输入正确的门限值,门限值在0到200之间");
            return;
          }
          break;
        case "AmbienTemperature":
          value = Number(value);
          this.Config.AmbienTemperature = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }

          if (value < 0 || value > 200) {
            this.$message.warning("请输入正确的门限值,门限值在0到200之间");
            return;
          }
          break;
        case "TimeOfDeparture":
          value = Number(value);
          this.Config.TimeOfDeparture = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }

          if (value < 0 || value > 300) {
            this.$message.warning("请输入正确的门限值,门限值在0到300之间");
            return;
          }
          break;
        case "CallRemainingTime":
          value = Number(value);
          this.Config.CallRemainingTime = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }

          if (value < 0 || value > 100) {
            this.$message.warning("请输入正确的门限值,门限值在0到100之间");
            return;
          }
          break;
        case "CallPressure":
          value = Number(value);
          this.Config.CallPressure = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }
          if (value < 0 || value > 40) {
            this.$message.warning("请输入正确的门限值,门限值在0到40之间");
            return;
          }
          break;
        case "BodySurfaceTemperatureMin":
          value = Number(value);
          this.Config.BodySurfaceTemperatureMin = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }
          if (value < 0 || value > 100) {
            this.$message.warning("请输入正确的门限值,门限值在0到100之间");
            return;
          }
          break;
        case "BloodOxygenMin":
          value = Number(value);
          this.Config.BloodOxygenMin = value;
          if (!Number.isInteger(value)) {
            this.$message.warning("请输入正确的门限值");
            return;
          }
          if (value < 0 || value > 100) {
            this.$message.warning("请输入正确的门限值,门限值在0到100之间");
            return;
          }
          break;
        default:
          break;
      }
      SetupService.ConfigEdit(this.Config).then(
        res => {
          if (res.status == 200 && res.data.status == 1000) {
            this.$message.warning("设置成功");
            this.editvisible = false;
            this.GetTroopConfig();
          } else if (res.status == 200) {
            this.GetTroopConfig();
            this.$message.warning(res.data.msg);
          } else {
            this.GetTroopConfig();
            this.$message.warning(res.message);
          }
        },
        err => {
          this.GetTroopConfig();
          this.$message.warning(err.message);
        }
      );
    },
    exit() {
      let _this = this;
      this.$confirm({
        title: "确定退出登录吗",
        // content: "原设置的值将会丢失",
        okText: "退出",
        cancelText: "取消",
        centered: true,
        width: 320,
        onOk() {
          sessionStorage.removeItem("Authorization"); 
          _this.$router.push({ name: "Login" }).catch(err => {console.error(err)});
        },
        onCancel() {}
      });
    },
    exitprogram() {
      this.$confirm({
        title: "确定退出程序吗",
        // content: "原设置的值将会丢失",
        okText: "退出",
        cancelText: "取消",
        centered: true,
        width: 320,
        onOk() {
          ipc.quit();
        },
        onCancel() {}
      });
    },
    updatePwd() {
      this.updatePwdvisible = true;
    },
    updatePwdOk() {
      let params = { Password: this.newPassword };
      SetupService.ChangePassword(params).then(
        res => {
          if (res.status == 200 && res.data.status == 1000) {
            this.$message.warning("修改密码成功，请前往登录页面登录");
            sessionStorage.removeItem("Authorization"); 
            this.$router.push({ name: "login" }).catch(err => {console.error(err)});
            this.editvisible = false;
            this.GetTroopConfig();
          } else if (res.status == 200) {
            this.GetTroopConfig();
            this.$message.warning(res.data.msg);
          } else {
            this.GetTroopConfig();
            this.$message.warning(res.message);
          }
        },
        err => {
          this.GetTroopConfig();
          this.$message.warning(err.message);
        }
      );
    }
  },
  watch: {
    Config(to, from) {
      //console.info(to);
    }
  }
};
</script>
<style lang="less">
.Setup {
  width: 100%;
  height: 100vh;
  background-color: #2d313a;
}
.Setup-head {
  font-size: 36px;
  color: #fff;
  height: 60px !important;
  background-color: #1f2730;
}
.Setup-head p {
  margin: -5px 0 0 15px;
  //border-left: 5px solid #3fdb23;
  padding: 0 0 0 15px;
}
.Setup-head p::before {
  font-size: 40px;
  content: "|";
  color: #3fdb23;
  font-weight: bold;
  margin-right: 15px;
}
.Setup-head a {
  color: #ccc;
}
#Setup-content.ant-collapse {
  border-radius: 0px;
  background-color: #2d313a;
  border: none;
  font-size: 16px;
}
#Setup-content.ant-collapse .ant-collapse-header {
  color: #3fdb23;
  border-radius: 0px;
  padding: 12px 0 12px 20px;
}
#Setup-content.ant-collapse .ant-collapse-content {
  border-radius: 0px;
  background-color: #576371;
  border: none;
}
#Setup-content.ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  padding: 0;
  border: none;
  color: #ddd;
}
#Setup-content.ant-collapse .ant-collapse-content-box .ant-row {
  border-bottom: 1px solid #aaa;
}
#Setup-content.ant-collapse .ant-collapse-content-box .ant-row:last-child {
  border-bottom: none;
}
#Setup-content.ant-collapse .ant-collapse-content-box .ant-row div {
  padding: 10px 0px 10px 40px;
}
#Setup-content.ant-collapse > .ant-collapse-item {
  border-radius: 0px;
  border-bottom: 1px solid #aaa;
}
#Setup-content.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow{
  left: auto;
  right: 16px;
}
.Setup-button {
  margin: 40px;
  text-align: center;
}
.Setup-button button.ant-btn {
  padding: 8px 12px !important;
  font-size: 18px !important;
  height: auto;
  margin: 0 50px;
  width: 150px;
}
.Setup .edit {
  background-image: url("../assets/images/modeling_img_tzjm.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  cursor: pointer;
}
.Setup .edit:active {
  background-image: url("../assets/images/modeling_img_tzjmOn.png");
}
.Setup-model .edit-select li {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #c0c0c0;
  cursor: pointer;
}
.Setup-model .edit-select li:last-child {
  border-bottom: none;
}
.Setup-model .edit-select li.checked {
  color: #3fdb23;
}
</style>

